export const token = ({ auth }) => auth?.token
export const userInfo = ({ auth }) => auth?.userInfo
export const featureFlags = ({ auth }) => auth?.featureFlags
export const permissions = ({ auth: { permissions } }) => permissions
export const accessTypes = ({ auth: { access_types } }) => access_types
export const userId = (state) => userInfo(state)?.id
